import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { formatFullName } from "@jti/fe-common";
import { handleAddPlusToPhone } from "@jti/rest-api";
import { formatPhoneNumber, useTranslations } from "@jti/ui";

import styles from "./ContactInfo.module.scss";

export type ContactInfoProps = {
  firstname?: string;
  lastname: string;
  telephone: string;
  fiscalCode?: string;
};

export const ContactInfo: FC<ContactInfoProps> = ({ firstname, lastname, telephone, fiscalCode }) => {
  const { __ } = useTranslations();
  const config = useConfig();
  const { isReversedNameOrder } = config;

  return (
    <div>
      <div className={styles.infoLine}>
        <span className={styles.label}>{__("contact_info.name")}:</span>
        <span>{formatFullName(firstname ?? "", lastname, isReversedNameOrder)}</span>
      </div>
      {!!telephone && (
        <div className={styles.infoLine}>
          <span className={styles.label}>{__("contact_info.phone_number")}:</span>
          <span>
            {formatPhoneNumber(
              handleAddPlusToPhone(telephone),
              config.isInternationalPhoneEnabled,
              config.PHONE_FORMAT
            )}
          </span>
        </div>
      )}
      {!!fiscalCode && (
        <div className={styles.infoLine}>
          <span className={styles.label}>{__("contact_info.fiscal_code")}:</span>
          <span>{fiscalCode}</span>
        </div>
      )}
    </div>
  );
};
